module.exports = __webpack_public_path__ + "media/images/activeIconRubric-fcd72281.png";